import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (this.element.dataset.action === "modal") {
      if (this.element.closest(".modal")) {
        this.replace();
      }
    }
  }

  replace() {
    this.element.innerHTML = this.element.dataset.content;
  }
}
